module.exports = __webpack_public_path__ + "img/heart-square.c45f4cd7.svg";